<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-teacherAssess__assessteacheritem">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(type,index) in typeList" :label="type.assessTypeName" :key="index" :name="'tab'+index">
          <el-card v-for="item in textMap[type.assessTypeId]" :key="item.id">
            <div slot="header" class="clearfix">
              <span style="display: inline-block;margin-left: 5%;font-weight: bold">{{item.assessItemName}}</span>
            </div>
            <el-form
                    :model="dataForm"
                    ref="dataForm"
                    :label-width="'120px'"
            >
              <el-col :span="20">
                <h4 style="display: inline-block;margin-left: 6%;font-weight: bold">{{item.assessItemContent}}</h4>
              </el-col>
              <el-col :span="4">
                <el-form-item label="自评分:" style="font-weight: bold" prop="teacherSex">
                  <span style="margin-left: 20px">{{item.evaluateScore}}</span>
                </el-form-item>
              </el-col>
              <el-row v-for="(basis,index1) in item.basisDTOList" :key="index1" style="border: #999999 1px solid;display: inline-block;width: 1550px">
                <el-col :span="16">
                  <el-form-item label="标题:"  style="margin-top: 10px;font-weight: bold" prop="resubmit">
                    <span style="margin-left: 20px">{{basis.title}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="图片:" prop="" style="height: 110px;font-weight: bold">
                    <el-image style="height: 120px;width: 120px;margin-left: 20px" v-for="img in basis.imgMapList" @click.stop="handleClickItem" :preview-src-list="basis.imgList" :key="img.url" :src="img.url"></el-image>
                    <!--<el-upload
                            v-model="basis.imgMapList"
                            :action="uploadUrl"
                            style="height: 100px;line-height: 100px;display: inline-block"
                            :on-preview="handlePictureCardPreview1"
                            :file-list="basis.imgMapList"
                            list-type="picture-card"
                            :on-remove="(file, fileList)=>{return Remove(file, fileList,index2, index1,type.assessTypeId,item)}"
                            data-id="199"
                            :on-success="(value)=> successImgUrl(index2, value,type.assessTypeId,index1,item)"
                            :before-upload="beforeUploadImg">
                      <i class="el-icon-plus"></i>
                    </el-upload>

                    <el-dialog append-to-body :visible.sync="dialogVisible">
                      <img
                              style="z-index: 4"
                              width="100%"
                              :src="imgUrl"
                              alt=""
                      >
                    </el-dialog>-->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-card>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      typeList: [],
      activeName: 'tab0',
      dialogVisible: false,
      imgUrl: '',
      textMap: {},
      uploadUrl: `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`,
      dataForm: {
        assessTeacherId: ''
      }
    }
  },
  watch: {
  },
  mounted () {
    this.dataForm.assessTeacherId = this.$route.params.id || 0
    this.getTypeInfo()
    this.getItemMap()
  },
  methods: {
    handleClickItem () {
      this.$nextTick(() => {
        const domImageMask = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    getTypeInfo () {
      this.$http.get('/teacherAssess/assessTeacherType/getAssessTypeList/' + this.dataForm.assessTeacherId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.typeList = res.data
      }).catch(() => {})
    },
    getItemMap () {
      this.$http.get('/teacherAssess/assessTeacherItem/getAssessItemMap', { params: { assessTeacherId: this.dataForm.assessTeacherId } }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.textMap = res.data
      }).catch(() => {})
    }
  },
  components: {
  }
}
</script>
